import * as Redux from 'redux';
import { ReduxPromiseAction, SimpleResponse } from '../app/app.types';
import { callApi } from '../util/ApiCaller';
import { pickAuthOrImpersonationToken } from '../util/token.util';
import { EmailTemplateActionTypes, EmailTemplatesResponseData, EmailResultResponseData } from './Types';
import {
  GET_EMAIL_TEMPLATES,
  GET_EMAIL_RESULTS,
  CREATE_EMAIL_TEMPLATE,
  UPDATE_EMAIL_TEMPLATE,
  DELETE_EMAIL_TEMPLATE
} from './Constants';

export const createEmailTemplate: Redux.ActionCreator<
  ReduxPromiseAction<
    EmailTemplateActionTypes, SimpleResponse<EmailTemplatesResponseData>
  >
> = (name: string, subject: string, html: string, automated: boolean, event: string,
  days: number, beforeAfter: string, active: boolean, content: string):
    ReduxPromiseAction<EmailTemplateActionTypes, SimpleResponse<EmailTemplatesResponseData>> =>
    ({
      type: CREATE_EMAIL_TEMPLATE,
      payload: callApi(
        process.env.REACT_APP_API + '/emailtemplate',
        true,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': pickAuthOrImpersonationToken()
          },
          body: JSON.stringify({ name, subject, html, automated, event, days, beforeAfter, active, content })
        }
      )
    });

export const getEmailTemplates: Redux.ActionCreator<
  ReduxPromiseAction<
    EmailTemplateActionTypes, SimpleResponse<EmailTemplatesResponseData>
  >
> = ():
    ReduxPromiseAction<EmailTemplateActionTypes, SimpleResponse<EmailTemplatesResponseData>> =>
    ({
      type: GET_EMAIL_TEMPLATES,
      payload: callApi(
        process.env.REACT_APP_API + '/emailtemplate/list',
        true,
        {
          method: 'GET',
          headers: {
            'Authorization': pickAuthOrImpersonationToken()
          }
        }
      )
    });

export const updateEmailTemplate: Redux.ActionCreator<
  ReduxPromiseAction<
    EmailTemplateActionTypes, SimpleResponse<EmailTemplatesResponseData>
  >
> = (id: number, name: string, subject: string, html: string, automated: boolean, event: string,
  days: number, beforeAfter: string, active: boolean, content: string):
    ReduxPromiseAction<EmailTemplateActionTypes, SimpleResponse<EmailTemplatesResponseData>> =>
    ({
      type: UPDATE_EMAIL_TEMPLATE,
      payload: callApi(
        process.env.REACT_APP_API + '/emailtemplate',
        true,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': pickAuthOrImpersonationToken()
          },
          body: JSON.stringify({ id, name, subject, html, automated, event, days, beforeAfter, active, content })
        }
      )
    });

export const deleteEmailTemplate: Redux.ActionCreator<
  ReduxPromiseAction<
    EmailTemplateActionTypes, SimpleResponse<EmailTemplatesResponseData>
  >
> = (id: number):
    ReduxPromiseAction<EmailTemplateActionTypes, SimpleResponse<EmailTemplatesResponseData>> =>
    ({
      type: DELETE_EMAIL_TEMPLATE,
      payload: callApi(
        process.env.REACT_APP_API + '/emailtemplate/' + id,
        true,
        {
          method: 'DELETE',
          headers: {
            'Authorization': pickAuthOrImpersonationToken()
          }
        }
      )
    });

  export const getEmailResults: Redux.ActionCreator<
  ReduxPromiseAction<
    EmailTemplateActionTypes, SimpleResponse<EmailResultResponseData>
  >
> = (subject: string):
    ReduxPromiseAction<EmailTemplateActionTypes, SimpleResponse<EmailResultResponseData>> =>
    ({
      type: GET_EMAIL_RESULTS,
      payload: callApi(
        process.env.REACT_APP_API + '/emailtemplate/results',
        true,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': pickAuthOrImpersonationToken()
          },
          body: JSON.stringify({ subject})
        }
      )
    });


// WEBPACK FOOTER //
// ./src/emailTemplate/Actions.tsx